import * as React from 'react';
import style from './check-box.scss';

export interface CheckBoxProps {
  name: string;
  label?: React.ReactNode;
  error?: string;
  helpText?: string;
  touched?: boolean;
}

type InputProps = JSX.IntrinsicElements['input'];

export function CheckBox(props: CheckBoxProps & InputProps) {
  const {label, error, helpText, name, required, touched, ...restProps} = props;

  const showHelp = Boolean(helpText);
  const showError = Boolean(touched && error);

  return (
    <>
      <input className="marketing-checkbox" id={name} name={name} type="checkbox" {...restProps} />
      <label className="marketing-checkbox-label" htmlFor={name}>
        {label}
        {showError && <span className={style.error}>{error}</span>}
        {showHelp && <span className={style.help}>{helpText}</span>}
      </label>
    </>
  );
}
